import { Link } from "react-router-dom";

import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchFeatureProductsAsync,
  selectFeatureProducts,
} from "../product/productSlice";

function HomeSection() {
  const dispatch = useDispatch();
  const featureProducts = useSelector(selectFeatureProducts);

  useEffect(() => {
    if(featureProducts.length<1){
      dispatch(fetchFeatureProductsAsync());
    }
  }, [dispatch]);
  return (
    <div className="bg-white">
      {/* Hero section */}
      <section className="bg-blue-600 py-20 mt-[-47px]">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="md:w-1/2 mb-8 md:mb-0">
              <h1 className="text-white font-bold text-5xl leading-tight mb-6">
                Discover the world's best coffee
              </h1>
              <p className="text-white text-xl mb-8">
                From hand-picked farms to your cup, we source the finest beans
                and roast them to perfection.
              </p>
              <Link to="/products">
                <a
                  href="#"
                  className="px-6 py-3 bg-white text-blue-600 font-bold rounded-full hover:bg-blue-700 transition duration-200"
                >
                  Shop now
                </a>
              </Link>
            </div>
            <div className="md:w-1/2">
              <img
                src="https://images.unsplash.com/photo-1601924638867-3a6de6b7a500?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="Coffee beans"
                className="w-full rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>
      {/* Featured section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-gray-800 mb-8">
            Featured Categories
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Wedges */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <img
                src="https://plus.unsplash.com/premium_photo-1668268751273-b0e8be5d3f03?q=80&w=1469&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="Wedges"
                className="w-full h-64 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  Fancy Wedges
                </h3>
                <p className="text-gray-700 text-base">
                  Elevate your style with our exquisite collection of wedges.
                  Perfect for casual outings and special occasions.
                </p>
                <div className="mt-4 flex items-center justify-between">
                  <span className="text-gray-700 font-medium">$10.99</span>
                  <Link to="/products">
                    <button className="px-4 py-2 bg-blue-600 text-white font-bold rounded-full hover:bg-blue-700 transition duration-200">
                      Shop Now
                    </button>
                  </Link>
                </div>
              </div>
            </div>
            {/* Sandals */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1534653299134-96a171b61581?q=80&w=1575&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="Sandals"
                className="w-full h-64 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  Stylish Sandals
                </h3>
                <p className="text-gray-700 text-base">
                  Discover comfort and style with our collection of sandals.
                  Perfect for sunny days and beach getaways.
                </p>
                <div className="mt-4 flex items-center justify-between">
                  <span className="text-gray-700 font-medium">$12.99</span>
                  <Link to="/products">
                    <button className="px-4 py-2 bg-blue-600 text-white font-bold rounded-full hover:bg-blue-700 transition duration-200">
                      Shop Now
                    </button>
                  </Link>
                </div>
              </div>
            </div>
            {/* Heels */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1574791418059-2e8d961ab4fb?q=80&w=1489&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="Heels"
                className="w-full h-64 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  Elegant Heels
                </h3>
                <p className="text-gray-700 text-base">
                  Step into sophistication with our collection of heels. Perfect
                  for formal events and evenings out.
                </p>
                <div className="mt-4 flex items-center justify-between">
                  <span className="text-gray-700 font-medium">$13.99</span>
                  <Link to="/products">
                    <button className="px-4 py-2 bg-blue-600 text-white font-bold rounded-full hover:bg-blue-700 transition duration-200">
                      Shop Now
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Recommendations section */}
      <section className="py-5">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-gray-800 mb-8">
            Recommendations
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {featureProducts.map((product, index) => (
              <Link to={`/product-detail/${product.id}`}>
                <div
                  key={index}
                  className="bg-white rounded-lg shadow-md overflow-hidden p-3"
                >
                  <img
                    src={product.thumbnail}
                    alt="Wedges"
                    className="w-full h-64 object-cover"
                  />
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-800 mb-2">
                      {product.title}
                    </h3>
                    <p className="text-gray-700 text-base">
                      {product.description.length > 100
                        ? product.description.substring(0, 100) + "..."
                        : product.description}
                    </p>
                    <div className="mt-4 flex items-center justify-between">
                      <span className="text-gray-700 font-medium">
                        ${product.discountedPrice}
                      </span>
                      <Link to={`/product-detail/${product.id}`}>
                        <button className="px-4 py-2 bg-blue-600 text-white font-bold rounded-full hover:bg-blue-700 transition duration-200">
                          Buy Now
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="px-3 py-5 bg-blue-600 lg:py-10 mt-10">
        <div className="grid lg:grid-cols-2 items-center justify-items-center gap-5">
          <div className="order-2 lg:order-1 flex flex-col justify-center items-center">
            <p className="text-4xl font-bold md:text-7xl text-orange-600">
              25% OFF
            </p>
            <p className="text-white text-4xl font-bold md:text-7xl">
              SUMMER SALE
            </p>
            <p className="text-white mt-2 text-sm md:text-lg">
              For limited time only!
            </p>
            <Link to="/products">
              <button className="text-lg md:text-2xl bg-white text-blue-600 py-2 px-5 font-bold mt-10 hover:bg-white">
                Shop Now
              </button>
            </Link>
          </div>
          <div className="order-1 lg:order-2">
            <img
              className="h-80 w-80 object-cover lg:w-[500px] lg:h-[500px]"
              src="https://images.unsplash.com/photo-1516762689617-e1cffcef479d?q=80&w=1422&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt=""
            />
          </div>
        </div>
      </section>

      <section className="py-20 px-10">
        <h2 className="text-4xl text-center font-bold text-gray-800 mb-8">
          Our Gallery
        </h2>
        <div className="grid lg:grid-cols-2 gap-3">
          <div className="grid grid-cols-2 lg:grid-cols-1 gap-3">
            <figure className="relative w-full h-60">
              <img
                className="w-full h-full absolute top-0 start-0 object-cover rounded-xl"
                src="https://images.unsplash.com/photo-1485570661444-73b3f0ff9d2f?q=80&w=1485&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="Image Description"
              />
            </figure>
            <figure className="relative w-full h-60">
              <img
                className="w-full h-full absolute top-0 start-0 object-cover rounded-xl"
                src="https://plus.unsplash.com/premium_photo-1667161521741-4f9fb075356f?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8bGFkaWVzJTIwc2hvZXN8ZW58MHx8MHx8fDA%3D"
                alt="Image Description"
              />
            </figure>
          </div>
          <figure className="relative w-full h-72 sm:h-96 lg:h-full">
            <img
              className="w-full h-full absolute top-0 start-0 object-cover rounded-xl"
              src="https://plus.unsplash.com/premium_photo-1671806266905-87fb9402929e?q=80&w=1374&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="Image Description"
            />
          </figure>
        </div>
      </section>

      <section id="new-features" className="py-8 bg-white sm:py-10 lg:py-16">
        <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl font-bold leading-tight text-gray-900 sm:text-4xl xl:text-5xl">
              Elevate Your Shoe Shopping Experience
            </h2>
            <p className="mt-4 text-base leading-7 text-gray-600 sm:mt-8">
              Explore our new features designed to make shoe shopping
              delightful.
            </p>
          </div>
          <div className="grid grid-cols-1 mt-10 text-center sm:mt-16 sm:grid-cols-2 sm:gap-x-12 gap-y-12 md:grid-cols-3 md:gap-0 xl:mt-24">
            {/* Feature 1: Shoe Selection */}
            <div className="md:p-8 lg:p-14 flex flex-col justify-center items-center">
              <div className="w-14 h-14 rounded-full bg-purple-200 flex justify-center items-center">
                <i className="fas fa-shopping-bag text-3xl text-gray-900" />
              </div>
              <h3 className="mt-12 text-xl font-bold text-gray-900">
                Trendy Collections
              </h3>
              <p className="mt-5 text-base text-gray-600">
                Explore our wide range of trendy shoe collections, curated for
                fashion enthusiasts like you.
              </p>
            </div>
            {/* Feature 2: Personalized Recommendations */}
            <div className="md:p-8 lg:p-14 md:border-l md:border-gray-200 flex flex-col justify-center items-center">
              <div className="w-14 h-14 rounded-full bg-teal-200 flex justify-center items-center">
                <i className="fas fa-heart text-3xl text-gray-900" />
              </div>
              <h3 className="mt-12 text-xl font-bold text-gray-900">
                Personalized Recommendation
              </h3>
              <p className="mt-5 text-base text-gray-600">
                Get personalized shoe recommendations tailored to your unique
                style preferences and good designs.
              </p>
            </div>
            {/* Feature 3: Easy Ordering */}
            <div className="md:p-8 lg:p-14 md:border-l md:border-gray-200 flex flex-col justify-center items-center">
              <div className="w-14 h-14 rounded-full bg-yellow-200 flex justify-center items-center">
                <i className="fas fa-cart-arrow-down text-3xl text-gray-900" />
              </div>
              <h3 className="mt-12 text-xl font-bold text-gray-900">
                Easy Ordering
              </h3>
              <p className="mt-5 text-base text-gray-600">
                Place your order hassle-free with our easy-to-use shopping cart
                and secure checkout process.
              </p>
            </div>
            {/* Feature 4: Fast Delivery */}
            <div className="md:p-8 lg:p-14 md:border-t md:border-gray-200 flex flex-col justify-center items-center">
              <div className="w-14 h-14 rounded-full bg-red-200 flex justify-center items-center">
                <i className="fas fa-truck text-3xl text-gray-900" />
              </div>
              <h3 className="mt-12 text-xl font-bold text-gray-900">
                Fast Delivery
              </h3>
              <p className="mt-5 text-base text-gray-600">
                Enjoy swift delivery of your favorite shoes right to your
                doorstep. We value your time.
              </p>
            </div>
            {/* Feature 5: Style Inspiration */}
            <div className="md:p-8 lg:p-14 md:border-l md:border-gray-200 md:border-t flex flex-col justify-center items-center">
              <div className="w-14 h-14 rounded-full bg-green-200 flex justify-center items-center">
                <i className="fas fa-tshirt text-3xl text-gray-900" />
              </div>
              <h3 className="mt-12 text-xl font-bold text-gray-900">
                Style Inspiration
              </h3>
              <p className="mt-5 text-base text-gray-600">
                Get inspired by our latest shoe styles and fashion tips to
                elevate your look with new styles.
              </p>
            </div>
            {/* Feature 6: Customer Support */}
            <div className="md:p-8 lg:p-14 md:border-l md:border-gray-200 md:border-t flex flex-col justify-center items-center">
              <div className="w-14 h-14 rounded-full bg-orange-200 flex justify-center items-center">
                <i className="fas fa-headset text-3xl text-gray-900" />
              </div>
              <h3 className="mt-12 text-xl font-bold text-gray-900">
                Exceptional Support
              </h3>
              <p className="mt-5 text-base text-gray-600">
                Experience top-notch customer support at every step of your shoe
                shopping journey.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
export default HomeSection;
